<script setup lang="ts">
import {
  AlertCircle,
  ArrowUpRight,
  Check,
  Circle,
  Clock3,
  PlugZap,
  ShieldCheck,
} from 'lucide-vue-next'
import { storeToRefs } from 'pinia'
import { useProjectStore } from '@/stores/domain'

const { activeProject } = storeToRefs(useProjectStore())
</script>

<template>
  <aside class="context-panel">
    <section class="context-section">
      <div class="context-section__head">
        <span class="eyebrow">Active project</span>
        <RouterLink to="/app/projects/sales-growth" aria-label="Open active project">
          <ArrowUpRight :size="16" />
        </RouterLink>
      </div>
      <div v-if="activeProject" class="active-project">
        <div class="active-project__title">
          <span class="health-dot"></span>
          <strong>{{ activeProject.name }}</strong>
        </div>
        <p>{{ activeProject.currentSummary }}</p>
        <div class="progress-row">
          <div class="progress-track">
            <span :style="{ width: `${activeProject.progressPercent}%` }"></span>
          </div>
          <strong>{{ activeProject.progressPercent }}%</strong>
        </div>
      </div>
    </section>

    <section class="context-section">
      <div class="context-section__head">
        <span class="eyebrow">Execution</span>
        <span class="muted-caption">Preview</span>
      </div>
      <div class="empty-execution">
        <span><Clock3 :size="16" /></span>
        <div>
          <strong>No active runs</strong>
          <p>Execution starts after billing and Manager provisioning.</p>
        </div>
      </div>
      <div class="queue-row">
        <Circle :size="9" fill="currentColor" />
        <span>Queue is clear</span>
        <strong>0</strong>
      </div>
    </section>

    <section class="context-section context-section--attention">
      <div class="context-section__head">
        <span class="eyebrow">Needs your attention</span>
        <span class="count-badge">2</span>
      </div>
      <RouterLink class="attention-item" to="/app/connections">
        <span class="attention-icon attention-icon--amber"><PlugZap :size="15" /></span>
        <div><strong>Connect HubSpot</strong><span>Required for pipeline research</span></div>
      </RouterLink>
      <RouterLink class="attention-item" to="/app/approvals">
        <span class="attention-icon attention-icon--purple"><ShieldCheck :size="15" /></span>
        <div><strong>Review outreach plan</strong><span>Approval required before send</span></div>
      </RouterLink>
    </section>

    <div class="security-note">
      <Check :size="14" />
      <span>Control state is server-owned</span>
      <AlertCircle :size="13" />
    </div>
  </aside>
</template>
